import moment from "moment";
import { useMemo } from "react";
import Enums from "../types/enums";
import { useDueDatesAuth } from "./useDueDatesAuth";

export const useSystemViews = () => {
  const { UserFullName } = useDueDatesAuth();
  const endOfNextMonth = moment().add(1, "month").endOf("month").toISOString();

  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .toISOString();

  const systemViews = useMemo(() => {
    return {
      AllTasks: {
        ViewType: Enums.ViewType.AllTasks,
        Filters: [
          {
            ColumnName: "DueDate",
            Operator: "greaterthanorequal^lessthan",
            Value: `${startOfLastMonth}^${endOfNextMonth}`
          },
          {
            ColumnName: "Stage",
            Operator: "notEqual",
            Value: "Completed"
          }
        ]
      },
      AssignedToMe: {
        ViewType: Enums.ViewType.AssignedToMe,
        Filters: [
          {
            ColumnName: "Assignee",
            Operator: "equal",
            Value: UserFullName ?? ""
          },
          {
            ColumnName: "Stage",
            Operator: "notEqual",
            Value: "Completed"
          },
          {
            ColumnName: "DueDate",
            Operator: "greaterthanorequal^lessthan",
            Value: `${startOfLastMonth}^${endOfNextMonth}`
          }
        ]
      },
      OverdueTasks: {
        ViewType: Enums.ViewType.OverdueTasks,
        Filters: [
          {
            ColumnName: "DueDate",
            Operator: "lessThan",
            Value: moment().endOf("day").toISOString()
          },
          {
            ColumnName: "Stage",
            Operator: "notEqual",
            Value: "Completed"
          }
        ]
      },
      RelatedToMe: {
        ViewType: Enums.ViewType.RelatedToMe,
        Filters: [
          {
            ColumnName: "RelatedUsers",
            Operator: "contains",
            Value: UserFullName ?? ""
          },
          {
            ColumnName: "Stage",
            Operator: "notEqual",
            Value: "Completed"
          },
          {
            ColumnName: "DueDate",
            Operator: "greaterthanorequal^lessthan",
            Value: `${startOfLastMonth}^${endOfNextMonth}`
          }
        ]
      },
      Completed: {
        ViewType: Enums.ViewType.CompletedTasks,
        Filters: [
          {
            ColumnName: "Stage",
            Operator: "equal",
            Value: "Completed"
          },
          {
            ColumnName: "DueDate",
            Operator: "greaterThan",
            Value: moment().startOf("year").toISOString()
          }
        ]
      },
      MyCompletedTasks: {
        ViewType: Enums.ViewType.MyCompletedTasks,
        Filters: [
          {
            ColumnName: "RelatedUsers",
            Operator: "contains",
            Value: UserFullName
          },
          {
            ColumnName: "Stage",
            Operator: "equal",
            Value: "Completed"
          }
        ]
      }
    };
  }, [UserFullName]);

  const getSystemView = (viewType) => {
    return Object.values(systemViews).find(
      (view) => view.ViewType === viewType
    );
  };

  return {
    getSystemView,
    systemViews
  };
};
